/**
 * Import all your frontend.js files here
 * 
 * !!!!!!!!!Let op:!!!!!!!!!!! 
 * Al deze frontend plugins apart benoemen in de INIT.PHP!!!!!
 * 
 * Dit heeft te maken met de fouten die sommige scripts kunnen veroorzaken als ze niet door de blokken worden aangeroepen in de rest van de admin.
 *  
 */
import './project-slider/frontend.js';
import './project-masonry/frontend.js';
